import {
  SWITCH_CUSTOMER,
  SWITCH_CUSTOMER_CANCEL,
  SELECT_CUSTOMER_SUCCESS
} from '../customers/actions';

const defaultState = {
  isSelectingCustomer: false
};

export default function uiReducer(state = defaultState, action) {
  switch (action.type) {
    case SWITCH_CUSTOMER:
      return { ...state, isSelectingCustomer: true };

    case SWITCH_CUSTOMER_CANCEL:
    case SELECT_CUSTOMER_SUCCESS:
      return { ...state, isSelectingCustomer: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/ui/reducer.js